module.exports = __webpack_public_path__ + "static/media/task-list.115293f2.png";